import Vue from 'vue'
import Vuex from 'vuex'
import * as getters from './getters' // 导入响应的模块，*相当于引入了这个组件下所有导出的事例
import * as actions from './actions'
import * as mutations from './mutations'
 
Vue.use(Vuex)

// 首先声明一个需要全局维护的状态 state,比如 我这里举例的resturantName
const state = {
    navStatus:false,
    qhText:'zh-CN',
    isLogin:false,
    currentUser:null,
    token:'',
    isUserLogin:true,//是否为显示密码登录
    navName:'home',//定义选中的nav导航
    userMsg:{},//用户中心个人档案
    isHealth:false,//判断是否进入健康优选
    phyExPeoList:[],//体检人列表
    allUserMsg:{},//获取登录用户所有的信息
    quotaDetailsList:{},//额度明细
}
 
// 注册上面引入的各大模块
const store = new Vuex.Store({
    state,    // 共同维护的一个状态，state里面可以是很多个全局状态
    getters,  // 获取数据并渲染
    actions,  // 数据的异步操作
    mutations  // 处理数据的唯一途径，state的改变或赋值只能在这里
})
 
export default store  // 导出store并在 main.js中引用注册。


// WEBPACK FOOTER //
// ./src/store/index.js